var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavBuySell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.69995 8.4999V5.0999C1.69995 4.16102 2.46107 3.3999 3.39995 3.3999H8.49995",
    stroke: "currentColor",
    strokeWidth: 1.275
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80005 0.850098L9.35005 3.4001L6.80005 5.9501",
    stroke: "currentColor",
    strokeWidth: 1.275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.85 3.4C17.85 5.27777 16.3278 6.8 14.45 6.8C12.5723 6.8 11.05 5.27777 11.05 3.4C11.05 1.52223 12.5723 0 14.45 0C16.3278 0 17.85 1.52223 17.85 3.4ZM12.2975 3.4C12.2975 4.58884 13.2612 5.55258 14.45 5.55258C15.6389 5.55258 16.6026 4.58884 16.6026 3.4C16.6026 2.21116 15.6389 1.24742 14.45 1.24742C13.2612 1.24742 12.2975 2.21116 12.2975 3.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1499 8.5001L16.1499 11.9001C16.1499 12.839 15.3888 13.6001 14.4499 13.6001L9.3499 13.6001",
    stroke: "currentColor",
    strokeWidth: 1.275
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0498 16.1499L8.4998 13.5999L11.0498 11.0499",
    stroke: "currentColor",
    strokeWidth: 1.275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-0.000195206 13.6C-0.000195042 11.7222 1.52204 10.2 3.39981 10.2C5.27757 10.2 6.79981 11.7222 6.7998 13.6C6.7998 15.4778 5.27757 17 3.3998 17C1.52204 17 -0.00019537 15.4778 -0.000195206 13.6ZM5.55239 13.6C5.55239 12.4112 4.58864 11.4474 3.39981 11.4474C2.21097 11.4474 1.24722 12.4112 1.24722 13.6C1.24722 14.7888 2.21097 15.7526 3.3998 15.7526C4.58864 15.7526 5.55239 14.7888 5.55239 13.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavBuySell);
export default __webpack_public_path__ + "static/media/icon-nav-buy-sell.81b5a296e83ed7694d148ac7782ba58f.svg";
export { ForwardRef as ReactComponent };